"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "trade-nav"
  }, [_c("img", {
    staticClass: "height-54",
    attrs: {
      src: require("../../assets/static/img/trade/02.png")
    }
  }), _c("div", {
    staticClass: "margin-top-60 flex-row-center align-item-center"
  }, [_c("div", {
    staticClass: "data-item flex-col-center"
  }, [_c("span", {
    staticClass: "font-36 color-white font-weight-500"
  }, [_vm._v("47,568,944票/年")]), _c("span", {
    staticClass: "font-16",
    staticStyle: {
      color: "#ffffffe6"
    }
  }, [_vm._v("货源总量")])]), _c("div", {
    staticClass: "data-item flex-col-center"
  }, [_c("span", {
    staticClass: "font-36 color-white font-weight-500"
  }, [_vm._v("1381万条")]), _c("span", {
    staticClass: "font-16",
    staticStyle: {
      color: "#ffffffe6"
    }
  }, [_vm._v("累计发布车源")])]), _c("div", {
    staticClass: "data-item flex-col-center"
  }, [_c("span", {
    staticClass: "font-36 color-white font-weight-500"
  }, [_vm._v("180000+")]), _c("span", {
    staticClass: "font-16",
    staticStyle: {
      color: "#ffffffe6"
    }
  }, [_vm._v("注册司机")])]), _c("div", {
    staticClass: "data-item flex-col-center"
  }, [_c("span", {
    staticClass: "font-36 color-white font-weight-500"
  }, [_vm._v("160000+")]), _c("span", {
    staticClass: "font-16",
    staticStyle: {
      color: "#ffffffe6"
    }
  }, [_vm._v("日均货源")])]), _c("div", {
    staticClass: "data-item flex-col-center"
  }, [_c("span", {
    staticClass: "font-36 color-white font-weight-500"
  }, [_vm._v("300000+")]), _c("span", {
    staticClass: "font-16",
    staticStyle: {
      color: "#ffffffe6"
    }
  }, [_vm._v("货主用户")])])])]);
}];
render._withStripped = true;